import React from "react";
import close from "../../../assets/images/model/close.svg";
import cross from "../../../assets/images/model/cross.svg";
const ChapterSelect = ({
  setGotoConfrimAuthor,
  setChapterSelect,
  setUploadLoadingBook,
  setTroubleModel,
  setLoadingBook,
  setSelectChapter,
  setThanksModel,
}) => {
  return (
    <div
      className="modal custom_background custom_modal_create"
      id="chapter_select"
      tabIndex="-1"
      style={{ display: "block" }}
      aria-labelledby="chapter_selectLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setSelectChapter(false);
                setThanksModel(false);
              }}
            >
              <img src={close} alt="close" />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>chapter select</h4>
            <p>
              Select each chapter title within your book. Any titles not
              selected will be set as sections under the chapter selected prior.
              If a title is neither a chapter or section, click the X icon to
              remove.
            </p>
            <form className="chapter_select_create">
              <div
                className="accordion my-40"
                id="accordionPanelsStayOpenExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne"
                    >
                      <div className="checkbox-wrapper-create">
                        <input id="Chapter_title_one" type="checkbox" />
                        <label
                          className="cbx"
                          htmlFor="Chapter_title_one"
                        ></label>
                        <label className="lbl" htmlFor="Chapter_title_one">
                          <span>1.0</span>Chapter title
                        </label>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseOne"
                    className="accordion-collapse collapse"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <div className="checkbox-wrapper-create">
                            <input id="Section_title_one" type="checkbox" />
                            <label
                              className="cbx"
                              htmlFor="Section_title_one"
                            ></label>
                            <label className="lbl" htmlFor="Section_title_one">
                              <span>1.1</span>Section title
                            </label>
                            <a href="" className="close_title">
                              <img src={cross} alt="close" />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="checkbox-wrapper-create">
                            <input id="Section_title_two" type="checkbox" />
                            <label
                              className="cbx"
                              htmlFor="Section_title_two"
                            ></label>
                            <label className="lbl" htmlFor="Section_title_two">
                              <span>1.2</span>Section title
                            </label>
                            <a href="" className="close_title">
                              <img src={cross} alt="close" />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTwo"
                      aria-expanded="false"
                      aria-controls="panelsStayOpen-collapseTwo"
                    >
                      <div className="checkbox-wrapper-create">
                        <input id="Chapter_title_two" type="checkbox" />
                        <label
                          className="cbx"
                          htmlFor="Chapter_title_two"
                        ></label>
                        <label className="lbl" htmlFor="Chapter_title_two">
                          <span>2.0</span>Chapter title
                        </label>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseTwo"
                    className="accordion-collapse collapse"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <div className="checkbox-wrapper-create">
                            <input id="Section_title_one1" type="checkbox" />
                            <label
                              className="cbx"
                              htmlFor="Section_title_one1"
                            ></label>
                            <label className="lbl" htmlFor="Section_title_one1">
                              <span>2.1</span>Section title
                            </label>
                            <a href="" className="close_title">
                              <img src={cross} alt="close" />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="checkbox-wrapper-create">
                            <input id="Section_title_two2" type="checkbox" />
                            <label
                              className="cbx"
                              htmlFor="Section_title_two2"
                            ></label>
                            <label className="lbl" htmlFor="Section_title_two2">
                              <span>2.2</span>Section title
                            </label>
                            <a href="" className="close_title">
                              <img src={cross} alt="close" />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseThree"
                      aria-expanded="false"
                      aria-controls="panelsStayOpen-collapseThree"
                    >
                      <div className="checkbox-wrapper-create">
                        <input id="Chapter_title_three" type="checkbox" />
                        <label
                          className="cbx"
                          htmlFor="Chapter_title_three"
                        ></label>
                        <label className="lbl" htmlFor="Chapter_title_three">
                          <span>3.0</span>Chapter title
                        </label>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseThree"
                    className="accordion-collapse collapse"
                  >
                    <div className="accordion-body">
                      <ul>
                        <li>
                          <div className="checkbox-wrapper-create">
                            <input id="Section_title_one11" type="checkbox" />
                            <label
                              className="cbx"
                              htmlFor="Section_title_one11"
                            ></label>
                            <label
                              className="lbl"
                              htmlFor="Section_title_one11"
                            >
                              <span>3.1</span>Section title
                            </label>
                            <a href="" className="close_title">
                              <img src={cross} alt="close" />
                            </a>
                          </div>
                        </li>
                        <li>
                          <div className="checkbox-wrapper-create">
                            <input id="Section_title_two3" type="checkbox" />
                            <label
                              className="cbx"
                              htmlFor="Section_title_two3"
                            ></label>
                            <label className="lbl" htmlFor="Section_title_two3">
                              <span>3.2</span>Section title
                            </label>
                            <a href="" className="close_title">
                              <img src={cross} alt="close" />
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24"
                  onClick={() => {
                    setSelectChapter(false);
                    // setTroubleModel(true);
                    setLoadingBook(true);
                  }}
                >
                  Done selecting chapters
                </button>
                <button
                  type="button"
                  className="btn-white-create mb-24"
                  onClick={() => {
                    setSelectChapter(false);
                    setGotoConfrimAuthor(true);
                  }}
                >
                  Go back
                </button>
                <div className="par-trouble">
                  <div className="trouble">
                    Having trouble with your upload?
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChapterSelect;
